import { useTranslation } from "react-i18next";
import { Header } from "src/components";
import styles from './styles.module.css';
import useScrollToTop from "src/hooks/useScrollToTop";
import { memo, useEffect } from "react";
import AOS from "aos";

import introImg from "src/assets/images/about/intro.avif";
import activity from "src/assets/images/about/activity.avif";
import companyBuilding from "src/assets/images/about/company_building.avif";
import workforceImg from "src/assets/images/about/workforce.avif"
import { isRTL } from "src/utils/global";


interface ImageTextSectionType {
    imgSrc: string;
    title: string;
    content: any;
    reverse?: boolean;
    aos: string

}


const About = () => {
    const { t } = useTranslation(['about']);

    useScrollToTop();

    const timeline = t("company.timeline", { returnObjects: true }) as Record<string, string> || {};
    const locations = t("company.location_details", { returnObjects: true }) as string[] || [];

    useEffect(() => {
        AOS.init({ duration: 1000 }); // Initialize AOS with a default animation duration
    }, []);

    return (
        <div className={`${styles.about} ${isRTL() && styles.rtl}`}>
            <Header title={t("header.title")} />
            <div className="container">
                <section className={styles.overviewSection}>
                    <h3 className={styles.overviewTitle}>{t("company.introduction")}</h3>
                    <p className={styles.overviewText}>{t("company.overview")}</p>
                </section>

                <ImageTextSection
                    imgSrc={introImg}
                    title={t("company.history")}
                    content={
                        <ul>
                            {Object.entries(timeline).map(([year, description]) => (
                                <li key={year}><strong>{year}</strong>: {description}</li>
                            ))}
                        </ul>
                    }
                    aos="fade-up"
                />

                <ImageTextSection
                    imgSrc={activity}
                    title={t("company.current_activity")}
                    content={<p>{t("company.current_details")}</p>}
                    reverse
                    aos="fade-left"
                />

                <ImageTextSection
                    imgSrc={workforceImg}
                    title={t("company.staff")}
                    content={<p>{t("company.staff_details")}</p>}
                    aos="fade-right"
                />

                <ImageTextSection
                    imgSrc={companyBuilding}
                    title={t("company.locations")}
                    content={
                        <ul>
                            {locations.map((location, index) => (
                                <li key={index}>{location}</li>
                            ))}
                        </ul>
                    }
                    reverse
                    aos="fade-left"
                />
            </div>
        </div>
    );
};

const ImageTextSection = ({ imgSrc, title, content, reverse = false, aos }: ImageTextSectionType) => (
    <section className={`row ${reverse ? "flex-row-reverse" : ""} ${styles.row}`}
        data-aos={aos}
    >
        <div className="col-12 col-lg-6 m-auto">
            <h4>{title}</h4>
            {content}
        </div>
        <div className={`col-12 col-lg-6 m-auto ${reverse ? "pe-lg-4" : "ps-lg-4"}`}>
            <div className={styles.imgCon}>
                <img src={imgSrc} alt={title} loading="lazy" />
            </div>
        </div>
    </section>
);


export default memo(About);
